import PageShell from "./PageShell";
import PropertyManagers from "@/components/site/PropertyManagers";

export default function PartnersPage() {
  return (
    <PageShell testId="page-partners">
      <PropertyManagers />
    </PageShell>
  );
}
